<template>
	<section class="container-components">
		<div class="flex flex-start w-full justify-between">
			<Search width="40%" height="40px" class="pl-3" @searchtext="(text) => (searchText = text)" />
			<div class="flex flex-row">
				<Button
					height="40px"
					width="150px"
					margin-left="10px"
					border-radius="5px"
					title="Criar Grupo"
					:icon="{ type: 'plus', size: '14px', color: '#219653' }"
					@click="modalCriarGrupo = !modalCriarGrupo"
				/>
			</div>
		</div>
		<div class="w-full flex mt-5">
			<div
				class="section-componentes w-full flex flex-wrap"
				:class="{ 'justify-between': gruposBuscados.length >= 4 }"
			>
				<Grupo
					v-for="(grupo, index) of gruposBuscados"
					:key="index"
					:data="grupo"
					:class="{ 'mr-4': gruposBuscados.length < 4 }"
					@selected="(id) => dropdownActions({ action: 'edit', id })"
					@dropdown-action="dropdownActions($event)"
				/>
			</div>
		</div>
		<Modal
			v-if="modalExcluirGrupo"
			title="Excluir grupo"
			width="30%"
			max-width="600px"
			@closemodal="modalExcluirGrupo = !modalExcluirGrupo"
		>
			<template v-slot:modalcontent>
				<p class="text-center">Você está prestes a excluir esse grupo. Tem certeza disso?</p>
				<div class="flex flex-row mt-4 items-center justify-center">
					<Button
						height="40px"
						margin-left="10px"
						width="150px"
						border-radius="5px"
						title="Cancelar"
						background-color="#d00000"
						title-color="#FFF"
						:icon="{
							type: 'x',
							size: '14px',
							color: '#FFF',
						}"
						@click="modalExcluirGrupo = false"
					/>
					<Button
						height="40px"
						width="150px"
						margin-left="10px"
						border-radius="5px"
						title="Excluir"
						title-color="#FFF"
						background-color="#219653"
						:icon="{
							type: 'save',
							size: '14px',
							color: '#FFF',
						}"
						@click="deleteGrupo()"
					/>
				</div>
			</template>
		</Modal>
		<Modal
			v-if="modalCriarGrupo"
			title="Criar Grupo"
			width="30%"
			max-width="600px"
			@closemodal="modalCriarGrupo = !modalCriarGrupo"
		>
			<template v-slot:modalcontent>
				<form method="POST" @submit="createGrupo($event)">
					<div class="input-group flex flex-col mb-2">
						<label for="titulo">Título:</label>
						<input v-model="formData.titulo" required type="text" name="titulo" />
					</div>
					<div class="flex flex-row mt-4 items-center justify-center">
						<Button
							height="40px"
							margin-left="10px"
							width="150px"
							border-radius="5px"
							title="Cancelar"
							background-color="#d00000"
							title-color="#FFF"
							:icon="{
								type: 'x',
								size: '14px',
								color: '#FFF',
							}"
							@click="modalCriarGrupo = !modalCriarGrupo"
						/>
						<Button
							height="40px"
							width="150px"
							margin-left="10px"
							border-radius="5px"
							title="Salvar"
							title-color="#FFF"
							background-color="#219653"
							:icon="{
								type: 'save',
								size: '14px',
								color: '#FFF',
							}"
						/>
					</div>
				</form>
			</template>
		</Modal>
	</section>
</template>

<script>
import Search from '@/layout/components/search/new';
import Button from '@/layout/components/buttons/Default';
import Grupo from '@/layout/components/cards/grupo';
import * as ecAxios from '@/util/ecAxios';
import Modal from '@/layout/components/modal/centered';

export default {
	components: {
		Search,
		Button,
		Grupo,
		Modal,
	},
	data() {
		return {
			grupos: [],
			searchText: '',
			errorToastOptions: {
				position: 'bottom-right',
				timeout: 5000,
				closeOnClick: true,
				pauseOnFocusLoss: true,
				pauseOnHover: true,
				draggable: true,
				draggablePercent: 0.6,
				showCloseButtonOnHover: false,
				hideProgressBar: true,
				closeButton: 'button',
				icon: true,
				rtl: false,
			},
			formData: {
				titulo: '',
				descricao: '',
			},
			modalCriarGrupo: false,
			grupoIdSelecionado: null,
			modalExcluirGrupo: false,
		};
	},
	computed: {
		gruposBuscados() {
			return this.grupos.filter((item) => {
				if (item.titulo.toUpperCase().includes(this.searchText.toUpperCase())) {
					return true;
				}
				return false;
			});
		},
	},
	created() {
		this.getAllGrupos();
	},
	methods: {
		dropdownActions(info) {
			switch (info.action) {
				case 'edit':
					this.$router.push({ path: `/produtos/grupos/${info.id}` });
					break;
				case 'delete':
					this.modalExcluirGrupo = true;
					this.grupoIdSelecionado = info.data.id;
					break;
				default:
					break;
			}
		},
		async deleteGrupo() {
			this.modalExcluirGrupo = false;
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.PRODUTO_GRUPO}/${this.grupoIdSelecionado}`;
				const { data } = await ecAxios.connection().delete(url);
				if (!data.error) {
					this.getAllGrupos();
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error.message, 'Erro', this.errorToastOptions);
			}
		},
		async getAllGrupos(search = null, orderBy = 'ordem', direction = 'asc') {
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.PRODUTO_GRUPO}`;
				const { data } = await ecAxios.connection().get(url, {
					params: {
						search,
						orderBy,
						direction,
					},
				});
				if (!data.error) {
					this.grupos = data.grupos;
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error, 'Erro', this.errorToastOptions);
			}
		},
		async createGrupo(e) {
			e.preventDefault();
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.PRODUTO_GRUPO}`;
				const { data } = await ecAxios.connection().post(url, this.formData);
				if (!data.error) {
					this.modalCriarGrupo = false;
					this.getAllGrupos();
					this.formData = {
						titulo: '',
						descricao: '',
					};
					this.$router.push(`/produtos/grupos/${data.id}`);
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.warning(error.message, this.errorToastOptions);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import '~@/style/Global.css';

.input-group {
	label {
		font-size: 14px;
		color: #999;
		margin-bottom: 5px;
	}
	input {
		border: var(--default-border);
		border-radius: 4px;
		padding: 2px;
	}
	select {
		border: var(--default-border);
		border-radius: 4px;
		padding: 4px;
	}
}

.container-components {
	padding: 0;
	margin: 0;
	width: 100%;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
}
</style>

